module.exports = __webpack_public_path__ + "media/images/flags/16/Vietnam-e76d5bf77c120d2beac0ab7d12a2f65f.png";